import { createGlobalStyle } from 'styled-components';

/**
 * This file is stand in for the glide-data-grid/dist/index.css file.
 * Currently our webpack configuration does not support importing css files from node_modules.
 * import '@glideapps/glide-data-grid/dist/index.css';
 */
export const GlobalStyle = createGlobalStyle`

.gdg-mnuv029 {
  word-break: break-word;
  -webkit-touch-callout: default;
  padding-top: 6px
}

.gdg-mnuv029>* {
  margin: 0
}

.gdg-mnuv029 :last-child {
  margin-bottom: 0
}

.gdg-mnuv029 p img {
  width: 100%
}

.gdg-d19meir1 {
  position: absolute;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  --overlay-top: var(--d19meir1-0);
  left: var(--d19meir1-1);
  top: var(--d19meir1-0);
  min-width: var(--d19meir1-2);
  min-height: var(--d19meir1-3);
  width: -webkit-max-content;
  width: max-content;
  max-width: 400px;
  max-height: calc(100vh - var(--d19meir1-4));
  font-family: var(--gdg-font-family);
  font-size: var(--gdg-editor-font-size);
  text-align: start
}

@keyframes glide_fade_in-gdg-d19meir1 {
  0% {
      opacity: 0
  }

  to {
      opacity: 100%
  }
}

.gdg-d19meir1.gdg-style {
  border-radius: 2px;
  background-color: var(--gdg-bg-cell);
  box-shadow: 0 0 0 1px var(--gdg-accent-color),0 0 1px rgba(62,65,86,.4),0 6px 12px rgba(62,65,86,.15);
  animation: glide_fade_in-gdg-d19meir1 60ms 1
}

.gdg-d19meir1.gdg-pad {
  padding: var(--d19meir1-5) 8.5px 3px
}

.gdg-d19meir1 .gdg-clip-region {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 2px;
  flex-grow: 1
}

.gdg-d19meir1 .gdg-clip-region .gdg-growing-entry {
  height: 100%
}

.gdg-d19meir1 .gdg-clip-region input.gdg-input {
  width: 100%;
  border: 0;
  outline: none
}

.gdg-d19meir1 .gdg-clip-region textarea.gdg-input {
  border: 0;
  outline: none
}

.gdg-b1ygi5by {
  display: flex;
  flex-wrap: wrap;
  margin-top: auto;
  margin-bottom: auto
}

.gdg-b1ygi5by .boe-bubble {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--gdg-rounding-radius,10px);
  padding: 0 8px;
  height: 20px;
  background-color: var(--gdg-bg-bubble);
  color: var(--gdg-text-dark);
  margin: 2px
}

.gdg-b1ygi5by textarea {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0
}

.gdg-n15fjm3e {
  display: flex;
  margin: 6px 0 3px;
  color: var(--gdg-text-dark)
}

.gdg-n15fjm3e>input {
  font-size: var(--gdg-editor-font-size);
  padding: 0;
  font-family: var(--gdg-font-family);
  color: var(--gdg-text-dark);
  background-color: var(--gdg-bg-cell)
}

.gdg-d4zsq0x {
  display: flex;
  flex-wrap: wrap
}

.gdg-d4zsq0x .doe-bubble {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  height: 24px;
  background-color: var(--gdg-bg-cell);
  color: var(--gdg-text-dark);
  margin: 2px;
  border-radius: var(--gdg-rounding-radius,6px);
  box-shadow: 0 0 1px rgba(62,65,86,.4),0 1px 3px rgba(62,65,86,.4)
}

.gdg-d4zsq0x .doe-bubble img {
  height: 16px;
  object-fit: contain;
  margin-right: 4px
}

.gdg-d4zsq0x textarea {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0
}

.gdg-i2iowwq {
  display: flex;
  height: 100%
}

.gdg-i2iowwq .gdg-centering-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%
}

.gdg-i2iowwq .gdg-centering-container canvas,.gdg-i2iowwq .gdg-centering-container img {
  max-height: calc(100vh - var(--overlay-top) - 20px);
  object-fit: contain;
  -webkit-user-select: none;
  user-select: none
}

.gdg-i2iowwq .gdg-centering-container canvas {
  max-width: 380px
}

.gdg-i2iowwq .gdg-edit-icon {
  position: absolute;
  top: 12px;
  right: 0;
  width: 48px;
  height: 48px;
  color: var(--gdg-accent-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center
}

.gdg-i2iowwq .gdg-edit-icon>* {
  width: 24px;
  height: 24px
}

.gdg-i2iowwq textarea {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0
}

.gdg-u1rrojo {
  display: flex;
  flex-grow: 1;
  align-items: center;
  min-height: 21px
}

.gdg-u1rrojo .gdg-link-area {
  flex-grow: 1;
  flex-shrink: 1;
  cursor: pointer;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--gdg-link-color);
  -webkit-text-decoration: underline!important;
  text-decoration: underline!important
}

.gdg-u1rrojo .gdg-edit-icon {
  flex-shrink: 0;
  width: 32px;
  color: var(--gdg-accent-color);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center
}

.gdg-u1rrojo .gdg-edit-icon>* {
  width: 24px;
  height: 24px
}

.gdg-u1rrojo textarea {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0
}

.gdg-m1pnx84e {
  min-width: var(--m1pnx84e-0);
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  color: var(--gdg-text-dark)
}

.gdg-m1pnx84e .gdg-g1y0xocz {
  flex-shrink: 1;
  min-width: 0
}

.gdg-m1pnx84e .gdg-spacer {
  flex: 1
}

.gdg-m1pnx84e .gdg-edit-icon {
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--gdg-accent-color);
  padding: 0;
  height: 24px;
  width: 24px;
  flex-shrink: 0;
  transition: all "0.125s ease";
  border-radius: 6px
}

.gdg-m1pnx84e .gdg-edit-icon>* {
  width: 16px;
  height: 16px
}

.gdg-m1pnx84e .gdg-edit-hover:hover {
  background-color: var(--gdg-accent-light);
  transition: background-color .15s
}

.gdg-m1pnx84e .gdg-checkmark-hover:hover {
  color: #fff;
  background-color: var(--gdg-accent-color)
}

.gdg-m1pnx84e .gdg-md-edit-textarea {
  position: relative;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  margin-top: 25px;
  opacity: 0;
  padding: 0
}

.gdg-m1pnx84e .gdg-ml-6 {
  margin-left: 6px
}

.gdg-s1dgczr6 .dvn-scroller {
  overflow: var(--s1dgczr6-0);
  transform: translateZ(0)
}

.gdg-s1dgczr6 .dvn-hidden {
  visibility: hidden
}

.gdg-s1dgczr6 .dvn-scroll-inner {
  display: flex;
  pointer-events: none
}

.gdg-s1dgczr6 .dvn-scroll-inner>* {
  flex-shrink: 0
}

.gdg-s1dgczr6 .dvn-scroll-inner .dvn-spacer {
  flex-grow: 1
}

.gdg-s1dgczr6 .dvn-scroll-inner .dvn-stack {
  display: flex;
  flex-direction: column
}

.gdg-s1dgczr6 .dvn-underlay>* {
  position: absolute;
  left: 0;
  top: 0
}

.gdg-s1dgczr6 canvas {
  outline: none
}

.gdg-s1dgczr6 canvas * {
  height: 0
}

.gdg-izpuzkl {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  resize: none;
  white-space: pre-wrap;
  min-width: 100%;
  overflow: hidden;
  border: 0;
  background-color: transparent;
  font-size: var(--gdg-editor-font-size);
  line-height: 16px;
  font-family: var(--gdg-font-family);
  -webkit-text-fill-color: var(--gdg-text-dark);
  color: var(--gdg-text-dark);
  padding: 0;
  margin: 0
}

.gdg-izpuzkl::placeholder {
  color: var(--gdg-text-light)
}

.gdg-invalid .gdg-izpuzkl {
  -webkit-text-decoration: underline;
  text-decoration: underline;
  text-decoration-color: #d60606
}

.gdg-s69h75o {
  visibility: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  min-width: 100%;
  font-size: var(--gdg-editor-font-size);
  line-height: 16px;
  font-family: var(--gdg-font-family);
  color: var(--gdg-text-dark);
  margin: 0;
  padding: 0 0 2px
}

.gdg-g1y0xocz {
  position: relative;
  margin-top: 6px
}

.gdg-seveqep {
  position: absolute;
  top: 4px;
  right: 20px;
  background-color: var(--gdg-bg-cell);
  color: var(--gdg-text-dark);
  padding: 8px;
  border: 1px solid var(--gdg-border-color);
  border-radius: 6px;
  font-size: var(--gdg-editor-font-size);
  animation: gdg-search-fadein-gdg-seveqep .15s forwards
}

.gdg-seveqep.out {
  animation: gdg-search-fadeout-gdg-seveqep .15s forwards
}

.gdg-seveqep .gdg-search-bar-inner {
  display: flex
}

.gdg-seveqep .gdg-search-status {
  padding-top: 4px;
  font-size: 11px
}

.gdg-seveqep .gdg-search-progress {
  position: absolute;
  height: 4px;
  left: 0;
  bottom: 0;
  background-color: var(--gdg-text-light)
}

.gdg-seveqep input {
  width: 220px;
  color: var(--gdg-textDark);
  background-color: var(--gdg-bg-cell);
  border: 0;
  outline: none
}

.gdg-seveqep button {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  outline: none;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--gdg-text-medium)
}

.gdg-seveqep button:hover {
  color: var(--gdg-text-dark)
}

.gdg-seveqep button .button-icon {
  width: 16px;
  height: 16px
}

.gdg-seveqep button:disabled {
  opacity: .4;
  pointer-events: none
}

@keyframes gdg-search-fadeout-gdg-seveqep {
  0% {
      transform: translateX(0)
  }

  to {
      transform: translateX(400px)
  }
}

@keyframes gdg-search-fadein-gdg-seveqep {
  0% {
      transform: translateX(400px)
  }

  to {
      transform: translateX(0)
  }
}

.gdg-wmyidgi {
  position: relative;
  min-width: 10px;
  min-height: 10px;
  max-width: 100%;
  max-height: 100%;
  width: var(--wmyidgi-0);
  height: var(--wmyidgi-1);
  overflow: hidden;
  overflow: clip;
  direction: ltr
}

.gdg-wmyidgi>:first-child {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%
}

.gdg-r17m35ur {
  flex-grow: 1;
  border: none;
  outline: none;
  background-color: var(--gdg-bg-header-has-focus);
  border-radius: 9px;
  padding: 0 8px;
  box-shadow: 0 0 0 1px var(--gdg-border-color);
  color: var(--gdg-text-group-header);
  min-height: var(--r17m35ur-0);
  font: var(--gdg-header-font-style) var(--gdg-font-family)
}

.gdg-c1tqibwd {
  padding: 0 8px;
  display: flex;
  align-items: center;
  background-color: var(--gdg-bg-header)
}
`;
